export class Cursors {
  public static readonly Pointer = "pointer";
  public static readonly Grab = "grab";
  public static readonly Grabbing = "grabbing";
}